export default () => {
    return {
        mounted(duration = 100, originX = 50, originY = 50, reverse = false, scrollTrigger = true) {
            const direction = reverse ? -360 : 360;
            let stSettings = false;

            if (scrollTrigger) {
                stSettings = {
                    start: 'top 85%',
                    trigger: this.$refs.element
                };
            }

            gsap.to(this.$refs.element, {
                duration: duration,
                rotate: direction,
                transformOrigin: `${originX}% ${originY}%`,
                repeat: -1,
                ease: 'none',
                scrollTrigger: stSettings
            });
        }
    };
};
